import Vue from 'vue'
import Vuex from 'vuex'

import common from '@/store/modules/common'
import user from '@/store/modules/user'
import getters from '@/store/getters'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {},
  getters,
  mutations: {},
  actions: {},
  modules: { common, user }
})
